import React from 'react';
import { hot } from 'react-hot-loader';
import Image from '../Image/Image';
import Video from '../Video/Video';
import s from './InlineCategoryContent.scss';

const InlineCategoryContent = ({ inlineMedia, inlineCategoryContent }) => {
	if (!inlineMedia) return null;
	const filmContent = { ...inlineMedia.film, src: inlineMedia.film?.source?.url };
	if (inlineMedia.image.url) filmContent.poster = inlineMedia.image.url;

	return (
		<div className={[s.inlineCategoryContent, s[`inlineCategoryContent__${inlineCategoryContent}`]].join(' ')}>
			{
				inlineMedia.film.source ? (
					<Video content={filmContent} column={12} />
				) : (
					<Image content={inlineMedia} column={12} />
				)
			}
		</div>
	);
};

export default hot(module)(InlineCategoryContent);
